<nav class="nav nav-tabs">
    <a *ngFor="let tab of onglets" class="nav-item nav-link " 
      [name]="tab.name" 
      [ngClass]="{'disabled':editMode,'active':activeTabName==tab.name}"
      [href]="tab.href" 
      data-bs-toggle="tab" 
      [hidden]="tab.hidden()" 
      (click)="setTabActive($event)">{{tab.display}}</a>
</nav>

<div class="tab-content" *ngIf="supplier">
  <div class="tab-pane" [ngClass]="{'active':activeTabName=='tabDepenses'}" id="paneDepenses" [hidden]="!depensesVisible()">
    <div *ngIf="activeTabName=='tabDepenses'">
      <pilotage-depenses [tabName]="'tabDepenses'" [supplierId]="supplier.Id"  [reload]="reloadActiveTab" (editModeChange)="oneditModeChange($event)"></pilotage-depenses>
    </div>
  </div>
  <div class="tab-pane" [ngClass]="{'active':activeTabName=='tabSuiviAchats'}" id="paneSuiviAchats" [hidden]="!suiviAchatsVisible()">
    <div *ngIf="activeTabName=='tabSuiviAchats'">
      <pilotage-suivi-achats [tabName]="'tabSuiviAchats'" [supplierId]="supplier.Id"  [reload]="reloadActiveTab" (editModeChange)="oneditModeChange($event)"></pilotage-suivi-achats>
    </div>
  </div>
  <div class="tab-pane" [ngClass]="{'active':activeTabName=='tabCriticite'}" id="paneCriticite" [hidden]="!criticiteVisible()">
    <div *ngIf="activeTabName=='tabCriticite'">
      <pilotage-criticite [tabName]="'tabCriticite'" [supplierId]="supplier.Id" [reload]="reloadActiveTab"></pilotage-criticite>
    </div>
  </div>
  <div class="tab-pane" [ngClass]="{'active':activeTabName=='tabAnalyseFinanciere'}" id="paneAnalyseFinanciere" [hidden]="!analyseFinanciereVisible()">
    <div *ngIf="activeTabName=='tabAnalyseFinanciere'">
      <pilotage-analyse-financiere [tabName]="'tabAnalyseFinanciere'" [supplierId]="supplier.Id" [reload]="reloadActiveTab" (editModeChange)="oneditModeChange($event)"></pilotage-analyse-financiere>
    </div>
  </div>
  <div class="tab-pane" [ngClass]="{'active':activeTabName=='tabQualite'}" id="paneSuiviQualite" [hidden]="!suiviQualiteVisible()">
    <div *ngIf="activeTabName=='tabQualite'">
      <pilotage-suivi-qualite [tabName]="'tabQualite'" [supplierId]="supplier.Id" [reload]="reloadActiveTab" (editModeChange)="oneditModeChange($event)"></pilotage-suivi-qualite>
    </div>
  </div>
  <div class="tab-pane" [ngClass]="{'active':activeTabName=='tabMails'}" id="paneSupplierMails">
    <div *ngIf="activeTabName=='tabMails'">
      <pilotage-mails [tabName]="'tabMails'" [supplierId]="supplier.Id" [reload]="reloadActiveTab"></pilotage-mails>
    </div>
  </div>
</div>
